// extracted by mini-css-extract-plugin
export default {"layout":"f5a8262011 _6ab94cb004 _04b2e1377a","h_slide":"_0828904bb1","category":"_469345fd9b _56232eed04 c7e5180acc"};